import React from 'react'

// The sidebar's shared state outlives its tabs. It sits in a module of its own so a tab can read it without
// importing the whole sidebar.
export const DataContext = React.createContext()
